import React from 'react';

function Footer() {
  return (
    <div className="foot-container">
      <div className="footer">
        <p className="copyright colorwhite">copyright@2025</p>
        <p className="builtwith colorwhite">built with love@christian</p>
      </div>
    </div>
  );
}

export default Footer;
